import { useParams } from "react-router-dom";
import React, { useState, useEffect,useRef  } from 'react';
import { 
  Calendar,
  Clock,
  User,
  Tag,
  Share2,
  Facebook,
  Twitter,
  Linkedin,
  Link2,
  TrendingUp,
  MessageCircle,
  Eye,
  Heart,
  Bookmark,
  Send,
  Loader,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';
import Header from "../Header";
import Footer from "../Footer";
import api from '../api/Api';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function NewsViewPage({ isDarkMode, setIsDarkMode }) {
  const { code } = useParams();
  const hasFetched = useRef(false);
  const [liked, setLiked] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);
  const [articleData, setArticleData] = useState(null);
 
  const [relatedNews, setRelatedNews] = useState([]);
  const [email, setEmail] = useState('');
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loading, setLoading] = useState(true);
  
  // Estado para comentários
  const [commentForm, setCommentForm] = useState({
    nome: '',
    email: '',
    texto: ''
  });
  const [submittingComment, setSubmittingComment] = useState(false);


  const URL_BASE ='https://api.angonet.ao/public/img/blog/';
  //const URL_BASE = 'http://127.0.0.1:8000/storage/img/blog/';

useEffect(() => {

  document.title = "Notícias";
  if (code && !hasFetched.current) {
    hasFetched.current = true;
    fetchNoticia();
  }
}, [code]);


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!email) return;

  setLoadingSubmit(true);

  try {
    const payload = { email };

    const response = await api.AddContacto(payload);

    if (response) {
      toast.success('Inscrição realizada com sucesso!');
      setEmail('');
    }

  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Erro. Tente novamente.';
    toast.error(errorMsg);
  } finally {
    setLoadingSubmit(false);
  }
};



const handleCommentSubmit = async (e) => {
  e.preventDefault();

  if (!articleData?.code) return;

  // 🔒 Validações iguais ao backend
  if (!commentForm.nome.trim()) {
    toast.warning("Nome é obrigatório.");
    return;
  }

  if (commentForm.nome.length > 255) {
      toast.warning("Nome deve ter no máximo 255 caracteres.");
    return;
  }

  if (!commentForm.email.trim()) {
      toast.warning("Email é obrigatório.");
    return;
  }

  if (commentForm.email.length > 255) {
      toast.warning("Email deve ter no máximo 255 caracteres.");
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(commentForm.email)) {
      toast.warning("Email inválido.");
    return;



  }

  if (!commentForm.texto.trim()) {
      toast.warning("Comentário é obrigatório.");
    return;
  }

  if (commentForm.texto.length > 2000) {
      toast.warning("Comentário deve ter no máximo 2000 caracteres.");
    return;
  }

  setSubmittingComment(true);

  try {
const payload ={
      code: articleData.code,
      nome: commentForm.nome.trim(),
      email: commentForm.email.trim(),
      texto: commentForm.texto.trim(),
    };


    await api.AddComentario(payload);

    toast.success("Comentário enviado com sucesso! Aguarda aprovação.");

    // Limpar formulário
    setCommentForm({
      nome: "",
      email: "",
      texto: "",
    });

  } catch (error) {
    console.error("Erro ao enviar comentário:", error);
    toast.error("Erro ao enviar comentário. Tente novamente.");
  } finally {
    setSubmittingComment(false);
  }
};







const getTimeAgo = (dateString) => {
  const now = new Date();
  const past = new Date(dateString);
  const diffInSeconds = Math.floor((now - past) / 1000);

  if (diffInSeconds < 60)
    return `há ${diffInSeconds}s`;

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60)
    return `há ${diffInMinutes} min`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24)
    return `há ${diffInHours}h`;

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30)
    return `há ${diffInDays} dia${diffInDays > 1 ? "s" : ""}`;

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12)
    return `há ${diffInMonths} mês${diffInMonths > 1 ? "es" : ""}`;

  const diffInYears = Math.floor(diffInMonths / 12);
  return `há ${diffInYears} ano${diffInYears > 1 ? "s" : ""}`;
};











const fetchNoticia = async () => {
  setLoading(true);
  try {
    const payload= {code:code };
    const response = await api.ListNoticia(payload);
    const data = response.data || response;

    if (data && Array.isArray(data) && data.length > 0) {
      const noticia = data[0];

      const tagsArray = noticia.tags
        ? noticia.tags.split(',').map(tag => tag.trim().replace('#', ''))
        : [];

      setArticleData({
        id: noticia.id,
        title: noticia.titulo,
        category: noticia.categoria,
        featuredImage: `${URL_BASE}${noticia.img1}`,
        secondaryImage: noticia.img2 ? `${URL_BASE}${noticia.img2}` : null,
        author: {
          name: noticia.autor,
          avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(noticia.autor)}&background=3b82f6&color=fff&size=200`
        },
        publishDate: noticia.created_at,
        views: noticia.views,
        htmlContent: noticia.texto,
        tags: tagsArray,
        comentarios: noticia.comentarios ?? [], // 👈 IMPORTANTE
        code: noticia.code
      });


      
    }

  } catch (error) {
    console.error('Erro ao carregar notícia:', error);
  } finally {
    setLoading(false);
  }
};


  const fetchRelatedNews = async (categoria, currentId) => {
    try {
      const response = await api.ListNoticia();
      if (response && Array.isArray(response)) {
        const related = response
          .filter(n => n.categoria === categoria && n.id !== currentId)
          .slice(0, 3)
          .map(n => ({
            id: n.id,
            code: n.code,
            title: n.titulo,
            image: `${URL_BASE}${n.img1}`,
            category: n.categoria,
            date: n.created_at
          }));
        setRelatedNews(related);
      }
    } catch (error) {
      console.error('Erro ao carregar notícias relacionadas:', error);
    }
  };

  const handleShare = (platform) => {
    const url = window.location.href;
    const text = articleData?.title || '';
    
    const shareUrls = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      x: `https://x.com/intent/post?url=${url}&text=${text}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      copy: url
    };

    if (platform === 'copy') {
      navigator.clipboard.writeText(url);
      toast.success('Link copiado para área de transferência!');
    } else {
      window.open(shareUrls[platform], '_blank', 'width=600,height=400');
    }
  };

  const handleCommentChange = (e) => {
    setCommentForm({
      ...commentForm,
      [e.target.name]: e.target.value
    });
  };


 

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-AO', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    });
  };

  const calculateReadTime = (htmlContent) => {
    if (!htmlContent) return '5 min';
    const text = htmlContent.replace(/<[^>]*>/g, '');
    const words = text.split(/\s+/).length;
    const minutes = Math.ceil(words / 200);
    return `${minutes} min`;
  };

  if (loading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${
        isDarkMode ? 'bg-gray-900' : 'bg-white'
      }`}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
            Carregando notícia...
          </p>
        </div>
      </div>
    );
  }

  if (!articleData) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${
        isDarkMode ? 'bg-gray-900' : 'bg-white'
      }`}>
        <div className="text-center">
          <h2 className={`text-2xl font-bold mb-4 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Notícia não encontrada
          </h2>
          <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
            A notícia que procura não existe ou foi removida.
          </p>
        </div>
      </div>
    );
  }



const injectImageIntoContent = () => {
  if (!articleData?.htmlContent) return "";

  if (!articleData.secondaryImage)
    return articleData.htmlContent;

  const firstParagraphEnd = articleData.htmlContent.indexOf("</p>");

  if (firstParagraphEnd === -1)
    return articleData.htmlContent;

  const before = articleData.htmlContent.slice(0, firstParagraphEnd + 4);
  const after = articleData.htmlContent.slice(firstParagraphEnd + 4);

  const imageHTML = `
    <div style="margin:40px 0;">
      <img src="${articleData.secondaryImage}" 
           style="width:100%; border-radius:16px;" />
    </div>
  `;

  return before + imageHTML + after;
};





  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Animated Background Particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      {/* Article Header */}
      <article className="relative pt-20">
        {/* Featured Image (img1) */}
        <div className="relative h-[500px] overflow-hidden">
          <img
            src={articleData.featuredImage}
            alt={articleData.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200&h=600&fit=crop';
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
          
          <div className="absolute inset-0 flex items-end">
            <div className="max-w-4xl mx-auto w-full px-6 pb-12">
              <div className="inline-block px-4 py-2 bg-blue-600/80 backdrop-blur-sm rounded-full text-white text-sm font-semibold mb-4">
                {articleData.category}
              </div>
              <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
                {articleData.title}
              </h1>
              
              {/* Meta Info */}
              <div className="flex flex-wrap items-center gap-6 text-white/90">
                <div className="flex items-center space-x-2">
                  <img
                    src={articleData.author.avatar}
                    alt={articleData.author.name}
                    className="w-10 h-10 rounded-full border-2 border-white"
                  />
                  <span className="font-medium">{articleData.author.name}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Calendar size={18} />
                  <span>{formatDate(articleData.publishDate)}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Clock size={18} />
                  <span>  {getTimeAgo(articleData.publishDate)}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Eye size={18} />
                  <span>{articleData.views} visualizações</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="relative z-10 py-12 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-12 gap-12">
              {/* Main Content */}
              <div className="lg:col-span-8">
                <div className={`rounded-2xl p-8 md:p-12 ${
                  isDarkMode ? 'bg-gray-800 border border-white/10' : 'bg-white shadow-xl'
                }`}>
                  {/* Article Body - Rich Text HTML */}
                  <div 
                    className={`prose prose-lg max-w-none ${
                      isDarkMode ? 'prose-invert' : ''
                    }`}
                    style={{
                      color: isDarkMode ? '#d1d5db' : '#374151'
                    }}
                  dangerouslySetInnerHTML={{ __html: injectImageIntoContent() }}

                  />

 

                  {/* Tags */}
                  {articleData.tags.length > 0 && (
                    <div className="mt-12 pt-8 border-t border-gray-700">
                      <h3 className={`text-lg font-bold mb-4 ${
                        isDarkMode ? 'text-white' : 'text-gray-900'
                      }`}>
                        Tags
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {articleData.tags.map((tag, index) => (
                          <span
                            key={index}
                            className={`px-4 py-2 rounded-full text-sm cursor-pointer transition-all ${
                              isDarkMode
                                ? 'bg-gray-700 text-cyan-400 hover:bg-gray-600'
                                : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
                            }`}
                          >
                            #{tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Author Bio */}
                  <div className={`mt-12 p-6 rounded-xl ${
                    isDarkMode ? 'bg-gray-900 border border-white/10' : 'bg-gray-50'
                  }`}>
                    <div className="flex items-start space-x-4">
                      <img
                        src={articleData.author.avatar}
                        alt={articleData.author.name}
                        className="w-20 h-20 rounded-full"
                      />
                      <div>
                        <h4 className={`text-xl font-bold mb-1 ${
                          isDarkMode ? 'text-white' : 'text-gray-900'
                        }`}>
                          {articleData.author.name}
                        </h4>
                        <p className={`text-sm ${
                          isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                        }`}>
                          Autor
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Comments Section */}
                  <div className="mt-12">
                    <h3 className={`text-2xl font-bold mb-6 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                      Comentários ({articleData.comentarios.length})
                    </h3>

                    {/* Existing Comments */}
                    {articleData.comentarios.length > 0 && (
                      <div className="space-y-6 mb-8">
                        {articleData.comentarios.map((comment, index) => (
                          <div
                            key={comment.id || index}
                            className={`p-6 rounded-xl ${
                              isDarkMode ? 'bg-gray-900 border border-white/10' : 'bg-gray-50'
                            }`}
                          >
                            <div className="flex items-start space-x-4">
                              <img
                                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(comment.nome)}&background=random&size=48`}
                                alt={comment.nome}
                                className="w-12 h-12 rounded-full"
                              />
                              <div className="flex-1">
                                <div className="flex items-center justify-between mb-2">
                                  <h4 className={`font-bold ${
                                    isDarkMode ? 'text-white' : 'text-gray-900'
                                  }`}>
                                    {comment.nome}
                                  </h4>
                                  <span className={`text-xs ${
                                    isDarkMode ? 'text-gray-500' : 'text-gray-500'
                                  }`}>
                                    {comment.created_at ? formatDate(comment.created_at) : 'Recente'}
                                  </span>
                                </div>
                                <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                                  {comment.texto}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Comment Form */}
                    <div className={`p-6 rounded-xl ${
                      isDarkMode ? 'bg-gray-900 border border-white/10' : 'bg-gray-50'
                    }`}>
                      <h4 className={`text-lg font-bold mb-4 ${
                        isDarkMode ? 'text-white' : 'text-gray-900'
                      }`}>
                        Deixe um Comentário
                      </h4>
                      
                      <form onSubmit={handleCommentSubmit} className="space-y-4">
                        <div className="grid md:grid-cols-2 gap-4">
                          <input
                            type="text"
                            name="nome"
                            value={commentForm.nome}
                            onChange={handleCommentChange}
                            required
                            placeholder="Seu nome"
                            className={`px-4 py-3 rounded-lg outline-none transition-all ${
                              isDarkMode
                                ? 'bg-gray-800 border-2 border-gray-700 text-white placeholder-gray-400 focus:border-cyan-500'
                                : 'bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                            }`}
                          />
                          <input
                            type="email"
                            name="email"
                            value={commentForm.email}
                            onChange={handleCommentChange}
                            required
                            placeholder="Seu email"
                            className={`px-4 py-3 rounded-lg outline-none transition-all ${
                              isDarkMode
                                ? 'bg-gray-800 border-2 border-gray-700 text-white placeholder-gray-400 focus:border-cyan-500'
                                : 'bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                            }`}
                          />
                        </div>
                        
                        <textarea
                          name="texto"
                          value={commentForm.texto}
                          onChange={handleCommentChange}
                          required
                          rows="4"
                          placeholder="Seu comentário..."
                          className={`w-full px-4 py-3 rounded-lg outline-none transition-all resize-none ${
                            isDarkMode
                              ? 'bg-gray-800 border-2 border-gray-700 text-white placeholder-gray-400 focus:border-cyan-500'
                              : 'bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:border-blue-500'
                          }`}
                        ></textarea>

                        <button
                          type="submit"
                          disabled={submittingComment}
                          className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:shadow-xl transition-all disabled:opacity-50"
                        >
                          <Send size={18} />
                          <span>{submittingComment ? 'Enviando...' : 'Enviar Comentário'}</span>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <div className="lg:col-span-4">
                <div className="sticky top-24 space-y-6">
                  {/* Share & Actions */}
                  <div className={`rounded-2xl p-6 ${
                    isDarkMode ? 'bg-gray-800 border border-white/10' : 'bg-white shadow-xl'
                  }`}>
                    <h3 className={`text-lg font-bold mb-4 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                      Compartilhar
                    </h3>
                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={() => handleShare('facebook')}
                        className={`flex items-center justify-center space-x-2 p-3 rounded-lg transition-all ${
                          isDarkMode
                            ? 'bg-gray-700 hover:bg-blue-600 text-white'
                            : 'bg-gray-100 hover:bg-blue-600 text-gray-700 hover:text-white'
                        }`}
                      >
                        <Facebook size={18} />
                        <span className="text-sm">Facebook</span>
                      </button>
                      <button
                        onClick={() => handleShare('twitter')}
                        className={`flex items-center justify-center space-x-2 p-3 rounded-lg transition-all ${
                          isDarkMode
                            ? 'bg-gray-700 hover:bg-blue-400 text-white'
                            : 'bg-gray-100 hover:bg-blue-400 text-gray-700 hover:text-white'
                        }`}
                      >
                  
                        <Linkedin size={18} />
                        <span className="text-sm">LinkedIn</span>
                      </button>
                      <button
                        onClick={() => handleShare('copy')}
                        className={`flex items-center justify-center space-x-2 p-3 rounded-lg transition-all ${
                          isDarkMode
                            ? 'bg-gray-700 hover:bg-gray-600 text-white'
                            : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                        }`}
                      >
                        <Link2 size={18} />
                        <span className="text-sm">Copiar</span>
                      </button>
                    </div>
 
                  </div>

                  {/* Newsletter */}
                  <div className={`rounded-2xl p-6 ${
                    isDarkMode
                      ? 'bg-gradient-to-br from-blue-500/10 to-purple-500/10 border border-cyan-500/30'
                      : 'bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-200'
                  }`}>
                    <h3 className={`text-lg font-bold mb-3 ${
                      isDarkMode ? 'text-white' : 'text-gray-900'
                    }`}>
                      Newsletter
                    </h3>
                    <p className={`text-sm mb-4 ${
                      isDarkMode ? 'text-gray-400' : 'text-gray-600'
                    }`}>
                      Receba as últimas notícias direto no seu email
                    </p>
           <form onSubmit={handleSubmit}>
  <div
    className={`flex items-center rounded-xl overflow-hidden transition-all ${
      isDarkMode
        ? 'bg-gray-700 border-2 border-gray-600 focus-within:border-cyan-500'
        : 'bg-white border-2 border-gray-200 focus-within:border-blue-500 shadow-sm'
    }`}
  >
    <input
      type="email"
      required
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Seu email"
      disabled={loadingSubmit}
      className={`flex-1 px-4 py-3 outline-none bg-transparent text-sm ${
        isDarkMode
          ? 'text-white placeholder-gray-400'
          : 'text-gray-900 placeholder-gray-500'
      } ${loadingSubmit ? 'opacity-70 cursor-not-allowed' : ''}`}
    />

    <button
      type="submit"
      disabled={loadingSubmit}
      className={`flex items-center justify-center px-4 py-3 font-semibold text-white transition-all ${
        loadingSubmit
          ? 'bg-gradient-to-r from-blue-600 to-purple-600 opacity-80 cursor-not-allowed'
          : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:shadow-lg hover:shadow-blue-500/40'
      }`}
    >
      {loadingSubmit ? (
        <Loader size={18} className="animate-spin" />
      ) : (
        <Send size={18} />
      )}
    </button>
  </div>
</form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Related Articles */}
        {relatedNews.length > 0 && (
          <section className={`py-20 px-6 ${
            isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
          }`}>
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <h2 className={`text-3xl font-bold ${
                  isDarkMode ? 'text-white' : 'text-gray-900'
                }`}>
                  Artigos Relacionados
                </h2>
                <TrendingUp className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} size={32} />
              </div>

              <div className="grid md:grid-cols-3 gap-6">
                {relatedNews.map((article) => (
                  <a
                    key={article.id}
                    href={`/noticias/${article.code}`}
                    className={`group rounded-xl overflow-hidden cursor-pointer transition-all ${
                      isDarkMode
                        ? 'bg-gray-900 border border-white/10 hover:border-cyan-500/50'
                        : 'bg-white border border-gray-200 hover:border-blue-500/50 shadow-lg hover:shadow-2xl'
                    }`}
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        onError={(e) => {
                          e.target.src = 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400&h=250&fit=crop';
                        }}
                      />
                      <div className="absolute top-3 left-3 px-3 py-1 bg-blue-600 text-white text-xs font-semibold rounded-full">
                        {article.category}
                      </div>
                    </div>
                    <div className="p-5">
                      <h3 className={`text-lg font-bold mb-3 line-clamp-2 ${
                        isDarkMode ? 'text-white group-hover:text-cyan-400' : 'text-gray-900 group-hover:text-blue-600'
                      } transition-colors`}>
                        {article.title}
                      </h3>
                      <div className={`flex items-center justify-between text-xs ${
                        isDarkMode ? 'text-gray-500' : 'text-gray-500'
                      }`}>
                        <span>{formatDate(article.date)}</span>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </section>
        )}
      </article>

      <Footer isDarkMode={isDarkMode} />

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        /* Estilos para o conteúdo HTML rich text */
        .prose h1 {
          font-size: 2em;
          font-weight: bold;
          margin-top: 1em;
          margin-bottom: 0.5em;
        }

        .prose h2 {
          font-size: 1.5em;
          font-weight: bold;
          margin-top: 1.5em;
          margin-bottom: 0.5em;
        }

        .prose h3 {
          font-size: 1.25em;
          font-weight: bold;
          margin-top: 1.25em;
          margin-bottom: 0.5em;
        }

        .prose p {
          margin-bottom: 1em;
          line-height: 1.75;
        }

        .prose ul, .prose ol {
          margin: 1em 0;
          padding-left: 2em;
        }

        .prose li {
          margin: 0.5em 0;
        }

        .prose blockquote {
          border-left: 4px solid #3b82f6;
          padding-left: 1em;
          margin: 1.5em 0;
          font-style: italic;
          background: ${isDarkMode ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.05)'};
          padding: 1em;
          border-radius: 0.5em;
        }

        .prose strong {
          font-weight: 700;
        }

        .prose em {
          font-style: italic;
        }

        .prose u {
          text-decoration: underline;
        }
      `}</style>
                    <ToastContainer 
                position="top-right" 
                autoClose={3000}
                toastStyle={{ borderRadius: 12 }}
              />
    </div>
  );
}